<template>
  <c-modal :show="show" class="edit-asset" title="New Asset" size="xl" @update:show="toggle">
    <c-row>
      <c-col sm="12" md="4">
        <c-input
            v-model="asset.licenceName"
            label="Asset name"
            type="text"
            placeholder="Enter asset name"
            :lazy="false"
            :is-valid="checkIfValid('licenceName')"
            invalid-feedback="Please enter a asset name"
        />
        <c-select
            label="Asset type"
            placeholder="Select"
            :options="assetTypes"
            :is-valid="checkIfValid('entityType')"
            @update:value="
                  e => {
                    this.asset.entityType = e;
                  }
                "
        />
        <template v-if="sites.length">
          <c-select
              label="Associate this asset with a site(s)"
              placeholder="Select"
              :options="sites"
              @update:value="addSite"
          />
          <div v-if="asset.sites.length" class="ml-3 mb-3">
            <c-row class="mb-1" v-for="(site, i) in asset.sites" :key="`site_${i}`">
              <c-col sm="10">{{site.label}}</c-col>
              <c-col sm="2">
                <c-button size="sm" @click="removeSite(site.value)" color="primary">x</c-button>
              </c-col>
            </c-row>
          </div>
        </template>
        <template v-else>
          <p class="lead" style="padding: 50px; width: 100%; text-align: center">
            No sites have been added to your organisation.
          </p>
        </template>
        <template v-if="clients.length">
          <c-select
              label="Associate this asset with a client(s)"
              placeholder="Select"
              :options="clients"
              @update:value="addClient"
          />
          <div v-if="asset.clients.length" class="ml-3 mb-3">
            <c-row class="mb-1" v-for="(client, i) in asset.clients" :key="`site_${i}`">
              <c-col sm="10">{{client.label}}</c-col>
              <c-col sm="2">
                <c-button size="sm" @click="removeClient(client.value)" color="primary">x</c-button>
              </c-col>
            </c-row>
          </div>
        </template>
        <template v-else>
          <p class="lead" style="padding: 50px; width: 100%; text-align: center">
            No clients have been added to your organisation.
          </p>
        </template>
        <c-select
            label="Does this asset have a licences?"
            placeholder="Select"
            :options="yesNo"
            @update:value="
                  e => {
                    this.asset.assetHasLicence = e;
                  }
                "
        />
        <template v-if="asset.assetHasLicence === 'y'">
          <c-input
              v-model="asset.licenceSeats"
              label="Number of licences"
              type="text"
              :lazy="false"
              :is-valid="checkIfValid('licenceName')"
              invalid-feedback="Please enter a asset name"
          />
          <template v-if="sites.length">
            <c-select
                label="Licences are used on these site(s)"
                placeholder="Select"
                :options="sites"
                @update:value="
                    e => {
                      this.selectedSiteId = e;
                    }
                  "
            />
          </template>
          <template v-else>
            <p class="lead" style="padding: 50px; width: 100%; text-align: center">
              No sites have been added to your organisation.
            </p>
          </template>
        </template>
      </c-col>
      <c-col sm="12" md="4">
        <c-input
            v-model="asset.licenceStartDate"
            label="Asset Start Date"
            type="date"
            :lazy="false"
            :is-valid="checkIfValid('licenceStartDate')"
            invalid-feedback="Please enter a asset start date"
        />
        <c-input
            v-model="asset.licenceRenewDate"
            label="Asset End Date"
            type="date"
            :lazy="false"
            :is-valid="checkIfValid('licenceRenewDate')"
            invalid-feedback="Please enter a asset start date"
        />
        <c-select
            label="Does this asset have credientials?"
            placeholder="Select"
            :options="yesNo"
            @update:value="
                  e => {
                    this.asset.assetHasCredentials = e;
                  }
                "
        />
        <template v-if="asset.assetHasCredentials === 'y'">
          <c-input
              v-model="asset.credentials.username"
              label="Username"
              type="text"
              autocomplete="off"
          />
          <c-input
              v-model="asset.credentials.password"
              label="Password"
              type="password"
              autocomplete="off"
          />
          <c-input
              v-model="asset.assetUrl"
              label="Asset URL"
              type="text"
          />
        </template>
      </c-col>
      <c-col sm="12" md="4">
        <c-select
            label="Is this asset purchased?"
            placeholder="Select"
            :options="yesNo"
            @update:value="
                  e => {
                    this.asset.assetPurchased = e;
                  }
                "
        />
      </c-col>
    </c-row>

    <template v-slot:footer>
      <c-button-group>
        <c-button color="primary" :disabled="isSaving" @click="save">Create</c-button>
        <c-button color="secondary" @click="close">Cancel</c-button>
      </c-button-group>
    </template>
  </c-modal>
</template>

<script>
import { validationMixin } from 'vuelidate';
import {
  required,
} from 'vuelidate/lib/validators';
import { buildEndpoint } from '@/libs/buildEndPoint';
import Charges from '@/views/components/asset/charges.vue';

const YES_NO = [
  {
    value: 'n',
    label: 'No',
  },
  {
    value: 'y',
    label: 'Yes',
  },
];

const ASSET_TYPES = [
  {
    value: 'plugin',
    label: 'Plugin',
  },
  {
    value: 'theme',
    label: 'Theme',
  },
  {
    value: 'service',
    label: 'Service',
  },
  {
    value: 'hosting',
    label: 'Hosting',
  },
  {
    value: 'other',
    label: 'Other',
  },
];

export default {
  name: 'CreateAsset',
  mixins: [validationMixin],
  props: {
    show: Boolean,
  },
  data() {
    return {
      isSaving: false,
      asset: {
        licenceName: '',
        licenceSeats: 0,
        entityType: '',
        licenceStartDate: '',
        licenceRenewDate: '',
        assetHasLicence: 'n',
        assetHasCredentials: 'n',
        assetPurchased: 'n',
        credentials: {
          username: '',
          password: '',
        },
        assetUrl: '',
        sites: [],
        clients: [],
      },
      sites: [],
      clients: [],
      selectedSiteId: '',
      assetTypes: ASSET_TYPES,
      yesNo: YES_NO,
    };
  },
  computed: {
    isValid() {
      return !this.$v.asset.$invalid;
    },
    isDirty() {
      return this.$v.asset.$anyDirty;
    },
  },
  validations: {
    asset: {
      licenceName: {
        required,
      },
      entityType: {
        required,
      },
      licenceStartDate: {
        required,
      },
      licenceRenewDate: {
        required,
      },
    },
  },
  mounted() {
    this.getAllSites();
    this.getAllClients();
  },
  methods: {
    close() {
      this.asset = {
        licenceName: '',
        licenceSeats: 0,
        entityType: '',
        licenceStartDate: '',
        licenceRenewDate: '',
        assetHasLicence: 'n',
        assetHasCredentials: 'n',
        assetPurchased: 'n',
        credentials: {
          username: '',
          password: '',
        },
        assetUrl: '',
        sites: [],
        clients: [],
      };
      this.$v.$reset();
      this.$emit('close');
    },
    toggle(event) {
      if (!event) {
        this.$emit('close');
      }
    },
    checkIfValid(fieldName) {
      const field = this.$v.asset[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === '');
    },
    getAllSites() {
      this.$http
        .get(buildEndpoint('organisation-admin/organisation/get-all-sites'), {})
        .then((response) => {
          if (response.data.success) {
            this.sites = [{ value: '', label: 'Select' }].concat(response.data.data
              .map((site) => ({
                // eslint-disable-next-line no-underscore-dangle
                value: site._id,
                label: site.name,
              })));
          } else {
            this.error = response.data.message;
          }
        })
        .catch((error) => {
          this.error = error;
        });
    },
    getAllClients() {
      this.isLoading = true;
      this.$http
        .get(buildEndpoint(`clients/list/${this.$store.state.app.authenticatedUser.organisationId}`))
        .then((response) => {
          this.isLoading = false;
          if (response.data.success) {
            this.clients = response.data.data.map((client) => ({
              // eslint-disable-next-line no-underscore-dangle
              value: client._id,
              label: client.name,
            }));
            this.clients.unshift({
              value: null,
              label: 'Select a client',
            });
          }
        })
        .catch((error) => {
          this.clientError(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addSite(siteId) {
      this.asset.sites.push(this.sites.find((site) => site.value === siteId));
    },
    removeSite(siteId) {
      this.asset.sites = this.asset.sites.filter((site) => site.value !== siteId);
    },
    addClient(clientId) {
      this.asset.clients.push(this.clients.find((client) => client.value === clientId));
    },
    removeClient(clientId) {
      this.asset.clients = this.asset.clients.filter((client) => client.value !== clientId);
    },
    save() {
      this.$v.$touch();

      if (!this.isValid) {
        return;
      }
      this.isSaving = true;
      const asset = { ...this.asset };
      asset.sites = asset.sites.map((s) => ({
        _id: s.value,
        name: s.label,
      }));
      asset.clients = asset.clients.map((c) => ({
        _id: c.value,
        name: c.label,
      }));
      // asset.sites = asset.sites.map((s) => s.value);
      // asset.clients = asset.clients.map((c) => c.value);
      this.$http
        .post(buildEndpoint('asset/create'), asset)
        .then((response) => {
          this.isSaving = false;
          if (response.data.success) {
            this.$store.commit('addSuccessMessage', {
              header: 'Success',
              message: 'Asset created',
            });
            this.$emit('created');
            this.$emit('newAsset', response.data.data);
            this.close();
          } else {
            this.$store.commit('addErrorMessage', {
              header: 'Error',
              message: 'Error creating asset',
            });
          }
        })
        .catch((error) => {
          this.isSaving = false;
          this.$store.commit('addErrorMessage', {
            header: 'Error',
            message: error,
          });
        });
    },
  },
};
</script>
